angular.module('app.controllers.non-paginated-forms.esap', [])
    .controller("EsapController", function ($scope, $window, $http, appConstants) {
        $scope.aversion = appConstants.version;
        $scope.isOutSideOfCalifornia = false;
        $scope.form_processed = "";
        $scope.account = "";
        $scope.form_name = "Energy Savings Assistance Program";
        $scope.caprequired = appConstants.captchaRequired; // localhost = false otherwise true
        $scope.allowedChars = /^[A-z0-9-'.,\!\+\(\)\/ ]+$/;
        $scope.addressChars = /^[A-z0-9-'.,\!\+\(\)\/\# ]+$/;
        $scope.onlyNumbers = /^([0-9]*)$/;
        $scope.validEmail = /^([\w-+\!\#\$\%\&]+(?:\.[\w-+\!\#\$\%\&]+)*)@((?:[A-z0-9-)]+\.)*\w[A-z0-9-]{0,66})\.([A-z0-9-]{2,8}(?:\.[A-z0-9-]{8})?)$/i;
        $scope.validAccount = /^[1]{1}[1-6|9]{1}[1]{1}[0-9]{10}$/;
        $scope.form_info = [
            "Thank you for your interest in the Energy Savings Assistance Program. Please fill out the form and a program representative will contact you with further information."
        ];
        $scope.success_response = [
            "Your inquiry has been successfully sent."
        ];
        $scope.success_detail = [
            "Thank you for contacting Southwest Gas. Our normal business hours are 8am-5pm Monday through Friday excluding holidays."
        ];

        $scope.response_en = "Thank you for your interest. A program representative will be contacting you soon to gather further information.";

        $scope.response_msg = $scope.response_en;

        $window.setCapRequired = function (value) {
            $scope.caprequired = value;
            $scope.$digest();
            //   alert(value);
        };

        $scope.isCaliforniaAccount = function (value) {
            $scope.isOutSideOfCalifornia = false;
            if (value && (value.length > 3)) {
                var initialDigits = value.substring(0, 3);

                if ((initialDigits != "111") &&
                    (initialDigits != "121") &&
                    (initialDigits != "131") &&
                    (initialDigits != "141") &&
                    (initialDigits != "151") &&
                    (initialDigits != "161") &&
                    (initialDigits != "191")) {
                    //$scope.isOutSideOfCalifornia = true;
                }
            }

            // if ($scope.firstname == 'SWGShowAllFormValidations'){alert(value + " - " + $scope.isOutSideOfCalifornia);}

        };

        $scope.resetForm = function () {
            //alert($scope.resetForm);
            $scope.firstname = "";
            $scope.lastname = "";
            $scope.account = "";
            $scope.address = "";
            $scope.city = "";
            $scope.state = "";
            $scope.zipcode = "";
            $scope.phonenum = "";
            $scope.ownership = "";
            $scope.householdsize = "";
            $scope.annualincome = "";
            $scope.account = "";
            $scope.email = "";
            $('html,body').scrollTop(0);
        };
        $scope.resetForm();

        $scope.submit = function () {
            if ($scope.form_processed === "") {
                $scope.form_processed = "Processing . . .";
                var firstName = $scope.firstname,
                    lastName = $scope.lastname,
                    account = $scope.account,
                    address = $scope.address,
                    city = $scope.city,
                    state = $scope.state,
                    zip = $scope.zipcode,
                    phone = $scope.phonenum,
                    ownership = $scope.ownership,
                    householdsize = $scope.householdsize,
                    annualincome = $scope.annualincome, 
                    accountnumber = $scope.account,
                    email = $scope.email;
					
				if (!annualincome){
					annualincome = 'Blank';
				}	
				
				if (!householdsize){
					householdsize = 'Blank';
				}

                $.ajax({
                    url: "/swgasws/resources/form/esap/add",
                    type: "post",
                    dataType: 'json',
                    data: {
                        firstName: firstName,
                        lastName: lastName,
                        address: address.replace(/#/g, ":"),
                        city: city,
                        state: state,
                        zip: zip,
                        phone: phone,
                        ownership: ownership,
                        householdsize: householdsize,
                        annualincome: annualincome,
                        account: accountnumber,
                        email: email,
                        language: "en",
                        gRecaptchaResponse: grecaptcha.getResponse()
                    },
                    success: function (data) {
                        $scope.issuccessful = true;

                        switch (data.status) {
                            case 'success':
                
                                document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-good'>" + data.message + "</span><span class='form-sub-normal'> An ESA program contractor will be contacting you within the next five business days excluding holidays to schedule an appointment to review your qualifications.  If you have any questions, please contact us at </span><a href='tel:8778606020' style='color:#337ab7;'>877-860-6020</a>.</p>";
                                break;
                            case 'badrequest':
                                document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>" + data.message + " Please try again later.  The Webmaster has been notified of the following submission problem(s): <br /> " + data.sysmessage + "</span></p>";
                                break;
                            default:  // all other errors
                                document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>" + data.message + " The  Webmaster has been notified of this submission problem.</span></p>";
                        }  // end switch 
                        $scope.isDisabled = !0;
                        $scope.resetForm();
                    },
                    error: function (response) {
                        document.getElementById("responsemessage").innerHTML = "<p><br /><span class='form-sub-error'>Your Energy Savings Assistance Program inquiry has NOT been sent due to maintenance.  We apologize for the inconvenience at this time.  Please try again later.</span></p>";
                        $scope.resetForm();
                    }
                });
            }
        };
    });